import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import errorPage from "../views/errorPage.vue";
import register from "../views/register";
import scholarship from "../views/scholarship";
import membership_application from "../views/membership_application";
import activities from "../views/activities";
import contact_us from "../views/contact_us";
import glitAward from "../views/glitAward";
import glitAwardNormination from "../views/glitAwardNormination";
import glitRegistration from "../views/glitRegistration";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home"
    }
  },
  {
    path: "/scholarship",
    name: "scholarship",
    component: scholarship,
    meta: {
      title: "Scholarship"
    }
  },
  {
    path: "/contact-us",
    name: "contact",
    component: contact_us,
    meta: {
      title: "Contact Us"
    }
  },
  {
    path: "/membership-application",
    name: "membership",
    component: membership_application,
    meta: {
      title: "Membership"
    }
  },
  {
    path: "/activities",
    name: "activities",
    component: activities,
    meta: {
      title: "Activities"
    }
  },
  {
    path: "/glit-award",
    name: "glitAward",
    component: glitAward,
    meta: {
      title: "Activities"
    }
  },

  {
    path: "/glit-registration",
    name: "glitRegistration",
    component: glitRegistration,
    meta: {
      title: "Activities"
    }
  },
  {
    path: "/glit-award-normination",
    name: "glitAwardNormination",
    component: glitAwardNormination,
    meta: {
      title: "Activities"
    }
  },
  {
    path: "/register",
    name: "register",
    component: register,
    meta: {
      title: "Home"
    }
  },
  {
    path: "/404",
    component: errorPage
  },
  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
